export enum RouterUrl {
  Home = '/',
  User = '/user',
  Login = '/user/login',
  Registration = '/user/registration',
  RegistrationType = '/user/registration/choose-registration',
  QuickRegistrationFrontDNI = '/user/registration/auto-photo-front',
  QuickRegistrationBackDNI = '/user/registration/auto-photo-back',
  FrontalDNI = '/user/registration/edit-front-side-info',
  ReversoDNI = '/user/registration/edit-back-side-info',
  PersonalWorkInfo = '/user/registration/employment-info',
  PaymentInfo = '/user/registration/bank-info',
  PhotoFrontDNI = '/user/registration/manual-photo-front',
  PhotoBackDNI = '/user/registration/manual-photo-back',
  Selfie = '/user/registration/selfie',
  CreateApplicationPage = '/user/registration/create-application',
  ApplicationConsideration = '/user/take-loan/consideration',
  SigningAgreement = '/user/take-loan/signing-agreement',
  SigningExtensionAgreement = '/user/extension/signing-agreement',
  DocumentRequest = '/user/document-upload',
  // payment
  ChoosePaymentMethod = '/user/payment',
  sPayment = '/user/payment/offline',
  qPayment = '/user/payment/qr',
  bPayment = '/user/payment/online',
  cPayment = '/user/payment/bank-card',
  AddCard = '/user/new-card',
  AddBankAccount = '/user/account/new-bank-account',
  ChooseCard = '/user/available-cards',
  // account
  Account = '/user/account',
  AccountLoanHistory = '/user/account/loan-history',
  AccountPersonalInfo = '/user/account/personal-info',
  PaymentMethods = '/user/account/payment-methods',
  AccountReferralProgram = '/user/account/referral-program',
  AccountDocuments = '/user/account/documents',
  ShortLink = '/f/:slug',
  SelectPaymentOptionLink = '/f/:option/:slug',
  //
  // pincodes
  CreatePincode = '/user/pincode/create',
  //
  MoneyOnTheWay = '/user/money-on-the-way',
  Reclamation = '/user/reclamation',
  // block screen
  Oops = '/user/oops',
}
